export default __webpack_public_path__ + "static/media/bg-loop-clouds.467c818.webm";